<template>
  <b-row>
    <b-col cols="12" class="text-right">
      <b-button
        v-if="
          this.IsEdit_CompanySearch === true &&
            this.IsProvince_CompanySearch === false
        "
        class="col-2 ml-1"
        variant="outline-info"
        @click="onAttorneyBtnClicked"
        >ผู้ได้รับมอบอำนาจ</b-button
      >
      <b-button
        v-if="
          this.IsEdit_CompanySearch === true &&
            this.IsProvince_CompanySearch === false
        "
        class="col-2 ml-1"
        variant="outline-primary"
        @click="onEditBtnClicked"
        >แก้ไข</b-button
      >
      <b-button
        v-if="this.IsEdit_CompanySearch === true"
        class="col-2 ml-1"
        variant="danger"
        @click="onDeletedBtnClicked"
        >ลบ</b-button
      >
    </b-col>

    <b-col cols="12">
      <b-form-group label="รหัสผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)">
        <b-form-input v-model="company.compId" readonly="readonly" />
      </b-form-group>

      <b-form-group label="ชื่อผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)">
        <b-form-input v-model="company.companyDetail" readonly="readonly" />
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group label="ที่ตั้ง/ที่อยู่">
        <CompanyAddress
          v-if="company !== null && company !== undefined"
          :address="company.address"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BFormTextarea,
  BButton,
  BFormInput,
} from "bootstrap-vue";
import { VueAutosuggest } from "vue-autosuggest";

import CompanyAddress from "../components/CompanyAddress.vue";

import * as companyStore from "@/store/api/company/index.js";

export default {
  components: {
    BFormInput,
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BFormTextarea,
    VueAutosuggest,
    CompanyAddress,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    IsEdit_CompanySearch: {
      type: Boolean,
      required: false,
      default: true,
    },
    IsProvince_CompanySearch: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onDeletedBtnClicked() {
      console.log("onDeletedBtnClicked");
      this.$emit("handle-delete", this.company);
    },
    onEditBtnClicked() {
      console.log("onEditBtnClicked");
      this.$emit("handle-edit", this.company);
    },
    onAttorneyBtnClicked() {
      console.log("onAttorneyBtnClicked");
      this.$emit("handle-attorney", this.company);
    },
  },
};
</script>
